import * as actionTypes from './actions';
export const initialState = {
    modalOpen: false,
    modalType: null,
    items: {},
    selectedItem: {},
    templateType: 'published',
    currentPage: 1,
    itemsPerPage: 5,
    paginationMeta: {},
    reload: false,
    isLoading: true
};
const questionPromptReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setModalOpen:
            return {
                ...state,
                modalOpen: action.modalOpen
            };
        case actionTypes.setModalType:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.setItems:
            return {
                ...state,
                items: action.items
            };
        case actionTypes.setSelectedItem:
            return {
                ...state,
                selectedItem: action.selectedItem
            };
        case actionTypes.setTemplateType:
            return {
                ...state,
                templateType: action.templateType
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        case actionTypes.setItemsPerPage:
            return {
                ...state,
                itemsPerPage: action.itemsPerPage
            };
        case actionTypes.setPaginationMeta:
            return {
                ...state,
                paginationMeta: action.paginationMeta
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setIsLoading:
            return {
                ...state,
                isLoading: action.isLoading
            };
        default:
            return state;
    }
};

export default questionPromptReducer;
